import { render, staticRenderFns } from "./VisitedHistoryBar.vue?vue&type=template&id=332520de&scoped=true&"
import script from "./VisitedHistoryBar.vue?vue&type=script&lang=ts&"
export * from "./VisitedHistoryBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332520de",
  null
  
)

export default component.exports